import ProductComponent from "../components/ProductComponent";
import useProduct from "../hook/useProduct";

const ProductPage = () => {
    const product = useProduct();
    return <ProductComponent {...product} />
}
export default ProductPage;